import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from '../../components/Tooltip';
import * as S from './Tab.css';
export const Tab = (props) => {
    const { value, description, linkTo } = props;
    const infoIcon = !!description ? (_jsx(Tooltip, Object.assign({ title: description !== null && description !== void 0 ? description : '' }, { children: _jsx(S.InfoIconStyle, {}) }))) : undefined;
    return linkTo ? (_jsx(S.Link, Object.assign({ to: linkTo }, { children: _jsx(S.Tab, Object.assign({ id: `tab-${value}`, "aria-controls": `tabpanel-${value}`, icon: infoIcon }, props)) }))) : (_jsx(S.Tab, Object.assign({ id: `tab-${value}`, "aria-controls": `tabpanel-${value}`, icon: infoIcon }, props)));
};
